import { render } from "./AlertYesNo.vue?vue&type=template&id=794b7542"
import script from "./AlertYesNo.vue?vue&type=script&lang=js"
export * from "./AlertYesNo.vue?vue&type=script&lang=js"
script.render = render

export default script